export default "__VITE_ASSET__e750a85a__"